import hbkLogo from "assets/hbk-logo.png";

import { cn } from "../utils/cn";

const sizes = {
  sm: "h-9 w-9",
  md: "h-10 w-10",
  lg: "h-14 w-14",
} as const;

/**
 * The mark on a white plate, for any surface that is not white.
 *
 * The mark has navy in it, which disappears into a Dusk card, so on
 * the sign-in card it sits on white in both themes. The rail does the same with
 * its own plate. A fixed white here is deliberate, not a theme token.
 */
export function BrandPlate({
  size = "lg",
  className,
}: {
  size?: keyof typeof sizes;
  className?: string;
}) {
  return (
    <span
      className={cn("flex w-fit rounded-lg bg-white p-2", className)}
      data-testid="logo-plate"
    >
      <BrandMark size={size} />
    </span>
  );
}

export function BrandMark({
  size = "md",
  className,
}: {
  size?: keyof typeof sizes;
  className?: string;
}) {
  return (
    <img
      src={hbkLogo}
      alt="Holtzbrinck"
      data-testid="logo-mark"
      className={cn(sizes[size], "shrink-0 object-contain", className)}
    />
  );
}
